<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <UButton v-bind="$attrs" variant="subtle" color="neutral" size="xs" />
</template>
